import gql from "graphql-tag";

export const SUBSCRIBE_BANNERS_COUNT = gql`
subscription bannersCount($filter: String!, $type: uuid!){
  bannersCount: Banners_aggregate (where:{caption: {_ilike: $filter}, bannerType: {_eq: $type}}){
    aggregate{ count }
  }
}`

export const SUBSCRIBE_BANNERS = gql`
subscription banners($filter: String!, $type: uuid!, $offset: Int!, $limit: Int!){
  banners: Banners(where: {caption: {_ilike: $filter}, bannerType: {_eq: $type}}, offset: $offset, limit: $limit,order_by: {isActive: desc, updated_at:desc}){
    id
    caption
    imageUrl
    redirectUrl
    sequenceNo
    isActive
    redirectTo
    mobile 
    whatsappMessage 
    startTime 
    endTime 
    isSchedule 
    BannerImages(order_by: {created_at: asc}){ id path caption type thumbnail createdBy updatedBy}
    Clicks_aggregate { aggregate {
        uniqueCount: count(columns: userId, distinct: true)
        totalCount: count
    }} 
  }
}`
